import React, { useCallback } from 'react';
import i18next from 'i18next';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DefaultModal from './DefaultModal';
import { ModalsSelectors, MeSelectors } from '../../redux/selectors';

const ExtensionFeePaymentModal = ({ primaryAction }) => {
  const me = useSelector(MeSelectors.selectMe);
  const [t] = useTranslation();
  const navigate = useNavigate();
  const isShownModal = useSelector(ModalsSelectors.selectExtensionFeePaymentModalIsOpen)
    && !me?.permissions?.accessToProjectBlocked;
  const closeModal = () => {};

  const signOut = useCallback(() => {
    navigate('/logout');
  }, [navigate]);

  return (
    <DefaultModal
      isShown={isShownModal}
      closeModal={closeModal}
      primaryAction={primaryAction}
      secondaryAction={signOut}
      title={t('extensionFeePaymentModal.title', { ns: i18next.Namespace.COMMON })}
      message={t('extensionFeePaymentModal.msg', { ns: i18next.Namespace.COMMON })}
      secondaryBtnText={t('button.signOut', { ns: i18next.Namespace.COMMON })}
    />
  );
};

ExtensionFeePaymentModal.propTypes = {
  primaryAction: PropTypes.func.isRequired,
};

export default ExtensionFeePaymentModal;
